/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reaction/fight_back': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 4a6 6 0 000 12 6 6 0 000-12zm-4.33 8.75L10 5.25l4.33 7.5H5.67z"/><path pid="1" d="M10 3c3.859 0 7 3.141 7 7s-3.141 7-7 7c-3.86 0-7-3.141-7-7s3.14-7 7-7m0-1a8.001 8.001 0 000 16 8.001 8.001 0 000-16z"/>'
  }
})
